import request from '@/utils/request'
export function listBanner(query) {
    return request({
        url: '/oauth/server-oauth/slideItems/selectMyBanner',
        method: 'post',
        data: query
    })
}

export function listNewsInfo(query) {
    return request({
        url: '/system/server-newsInfo/info/list',
        method: 'get',
        params: query
    })
}

// 查询新闻资讯详细
export function getInfo(query) {
    return request({
        // url: '/system/server-newsInfo/info',
        url: '/system/server-newsInfo/info/' + query.id,
        method: 'get',
        params: query
    })
}

export function menHuClientList(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/menHuClientList',
        method: 'get',
        params: query
    })
}

export function menHuMutiClientList(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/menHuMutiClientList',
        method: 'get',
        params: query
    })
}

export function getMenHuClientDataList() {
    return request({
        url: '/oauth/server-exam/registeredClient/web/list',
        method: 'get'
    })
}

export function getClient(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/menHuClientDetail',
        method: 'get',
        params: query
    })
}

export function getDetailMutiClient(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/menHuMutiClientDetail',
        method: 'get',
        params: query
    })
}

// 获取指南列表
export function getGuideList(query) {
    return request({
        url: '/oauth/server-oauth/operationManual/list',
        method: 'get',
        params: query
    })
}

// 检查是否已注册家长
export function getParentsCheck() {
    return request({
        url: '/system/server-system/marketingActivity/getParentsCheck',
        method: 'get'
    })
}

// 记录轮播图点击量
export function clickSlideItem(id) {
    return request({
        url: `/oauth/server-oauth/slideItems/click/${id}`,
        method: 'get'
    })
}

// 获取用户是否是会员
export function checkUserFeatures(params) {
    return request({
        url: `/system/server-system/user-features/check`,
        method: 'get',
        params: params
    })
}

// 获取 AI 对话页面链接
export function getTalkUrl() {
    return request({
        url: '/system/server-system/messageRecord/getTalkUrl',
        method: 'get'
    })
}